import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import CheckboxIcon from '@capture/capture-components/src/icons/checkbox-checked.svg?react'
import UncheckedIcon from '@capture/capture-components/src/icons/checkbox-unchecked.svg?react'
import { colors } from '~/assets/styleConstants'
interface CheckboxProps {
    onClick: () => void
    checked?: boolean
    disabled?: boolean
}

const CheckboxWrapper = styled.span<CheckboxProps>`
    display: inline-flex;
    align-items: center;
    gap: 0.25em;
    font-size: 16px;
    cursor: ${(props) => (props?.disabled ? 'default' : 'pointer')};
    opacity: ${(props) => (props?.disabled ? 0.6 : 1)};
`

export const Checkbox = (props: PropsWithChildren<CheckboxProps>) => {
    const { children, onClick, checked, disabled } = props

    const Icon = checked ? CheckboxIcon : UncheckedIcon

    return (
        <CheckboxWrapper
            disabled={disabled}
            onClick={disabled ? () => undefined : onClick}
            onKeyUp={disabled ? () => undefined : onClick}
            role="button"
            tabIndex={0}>
            <Icon color={colors.captureBlue} />
            {children}
        </CheckboxWrapper>
    )
}
